import {
  useAppDispatch,
  useAppSelector,
} from "@/app/lib/features/redux/redux.hook";
import { useCallback } from "react";
import { getMenus } from "./menus.thunk";
import { resetMenus } from "./menus.slice";
import { isError, isIdle, isLoading, isSuccess } from "@/app/utils/asyncStatus";

const useMenus = () => {
  const dispatch = useAppDispatch();
  const menus = useAppSelector((store) => store.menus.data);
  const menusStatus = useAppSelector((store) => store.menus.status);
  const menusError = useAppSelector((store) => store.menus.error);

  const fetchMenus = useCallback(async () => {
    const result = await dispatch(getMenus());
    return result.meta.requestStatus === "fulfilled";
  }, [dispatch]);

  const reset = useCallback(() => {
    dispatch(resetMenus());
  }, [dispatch]);

  return {
    menus,
    menusError,
    menusStatus,
    isIdle: isIdle(menusStatus),
    isLoading: isLoading(menusStatus),
    isSuccess: isSuccess(menusStatus),
    isError: isError(menusStatus),
    fetchMenus,
    reset,
  };
};

export default useMenus;